import {Block} from "baseui/block";
import {forwardRef} from "react";

function FlexBlock (props, ref) {
    return (
        <Block display="flex" {...props} ref={ref} />
    )
}

export default forwardRef(FlexBlock);